module.exports = __webpack_public_path__ + "img/title2.a729db47.png";